// src/setupJSONPatch.js

(function () {
  const originalParse = JSON.parse;

  JSON.parse = function (str) {
    try {
      return originalParse(str);
    } catch (error) {
      console.error("Safe JSON.parse error:", error.message);
      return str; // or return null, {}, or any fallback value
    }
  };
})();
